<div [@routingTransition]="prepareRoute(o)" class="uploader-standard-router">
    <router-outlet #o="outlet"></router-outlet>
</div>